import React, { useState, useEffect } from 'react';
import './CurrentProcessCommercialTerms.scss';
import BuyersFeesTable from '../../../AdminMarketplace/MarketplaceTabs/MarketplaceSettings/BuyersFeesTable/BuyersFeesTable';
import {
    LoadMarketplacePricing,
    LoadMarketplaceTemplatePricing,
} from '../../../../slices/marketplace/pricing/load-marketplace-pricing.thunk';
import { useDispatch } from 'react-redux';
import { MarketplacePricing } from '../../../../slices/marketplace/pricing/models/marketplace-pricing.model';
import { BuyersFees } from '../../../../slices/marketplace/pricing/models/buyers-fees-model';
import createNotification from '../../../../utils/createNotification';
import moment from 'moment';

interface CurrentProcessCommercialTermsProps {
    engagementId?: number;
    showDateModified?: boolean;
}
const CurrentProcessCommercialTerms = (
    props: CurrentProcessCommercialTermsProps
) => {
    const dispatch = useDispatch() as any;
    const [settings, setSettings] = useState<MarketplacePricing>();
    const [loading, setLoading] = useState(false);

    const fetchCommercialTerms = async () => {
        setLoading(true);
        try {
            const response = props.engagementId
                ? await dispatch(LoadMarketplacePricing(props.engagementId))
                : await dispatch(LoadMarketplaceTemplatePricing());
            let pricingCopy: MarketplacePricing = JSON.parse(
                JSON.stringify(response.payload.data)
            );
            setSettings(pricingCopy);
        } catch (error) {
            createNotification('Failed to load commercial terms.', 'error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCommercialTerms();
    }, []);

    return (
        <div className="current-process-commercial-terms">
            <div className="body_header_title">
                <h5>
                    {props.engagementId
                        ? 'Buyer Fee Schedule'
                        : 'Connect Fee Schedule'}
                </h5>
            </div>
            <div className="commercial-terms-container">
                {loading ? (
                    <div className="loading-container">
                        <p>Loading commercial terms...</p>
                    </div>
                ) : settings ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center fees-header">
                            <h6>Buyers' Fees</h6>
                            {!!props.showDateModified ? (
                                <div>
                                    Date of Last Update:{' '}
                                    {moment(
                                        settings.buyersFees.dateModified
                                    ).format('l')}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <BuyersFeesTable
                            buyersFees={settings.buyersFees}
                            onChange={(newState: BuyersFees) => {}}
                            setFormFieldValue={() => {}}
                            formState={settings}
                            isViewMode={true}
                        />
                    </>
                ) : (
                    []
                )}
            </div>
        </div>
    );
};

export default CurrentProcessCommercialTerms;
